import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import RequirementsSection from './components/RequirementsSection';
import ProcessSection from './components/ProcessSection';
import ApplicationForm from './components/ApplicationForm';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';

const ForLawyers = () => {
  return (
    <>
      <Helmet>
        <title>Für Anwälte - Karriere bei AdvoCall Professional | Flexible Rechtsberatung</title>
        <meta 
          name="description" 
          content="Werden Sie Teil von AdvoCall Professional. Flexible Arbeitszeiten, überdurchschnittliche Vergütung und innovative Rechtsberatung. Jetzt als Anwalt bewerben!" 
        />
        <meta name="keywords" content="Anwalt Jobs, Rechtsanwalt Karriere, flexible Arbeitszeiten, telefonische Rechtsberatung, AdvoCall, Jurist Stellenangebote" />
        <meta property="og:title" content="Für Anwälte - Karriere bei AdvoCall Professional" />
        <meta property="og:description" content="Revolutionieren Sie Ihre Anwaltskarriere mit flexiblen Arbeitszeiten und innovativer Rechtsberatung bei AdvoCall Professional." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://advocall.de/for-lawyers" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="scroll-smooth">
          <HeroSection />
          <BenefitsSection />
          <RequirementsSection />
          <ProcessSection />
          <ApplicationForm />
          <TestimonialsSection />
          <FAQSection />
        </main>
      </div>
    </>
  );
};

export default ForLawyers;